// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Z9nm","field":"styles_field__1cYS2","fieldCol":"styles_fieldCol__3CJE0","diffCol":"styles_diffCol__5qCaS","diff":"styles_diff__1gybl"};